require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-3-tips-for-effectively-learning-swift.json") })
        }
      }, "path---blog-3-tips-for-effectively-learning-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-3-tips-for-effectively-learning-swift!./.cache/json/blog-3-tips-for-effectively-learning-swift.json
// module id = 557
// module chunks = 231608221292675